import React, {useState} from "react";
import {Avatar, Button, Col, Flex, Form, Input, List, Tag} from "antd";
import {StyledCard, StyledTag} from "./UserInformation.styled";
import style from "./UserInformation.module.scss" ;
import profilePic from "assets/Logo/512square.svg";
import VerifyIdentityPopup from "../../../../shared/components/verifyIdentity/VerifyIdentityPopup";
import {connect, useDispatch, useSelector} from "react-redux";
import {setValue} from "../../../../shared/slice/CurrentUser.slice";
import {getUser} from "../../../../shared";
import {withRouter} from "../../../../utils/services/with-router";
import {RootState} from "../../../../store/store";

const UserInformation = (props:any) => {
    const currentUser = useSelector((state: RootState) => state.currentUser.data.data);

    const [openVerificationModal, setOpenVerificationModal] = useState<boolean>(false);
    const onCansel = () => {
      setOpenVerificationModal(false);
    }

    const dispatch = useDispatch<any>();
    const getUserInfo = () => {
        props.getUser()
            .then((data: any) => {
                if (data.payload) {
                    dispatch(setValue(data.payload));
                }
            })
            .catch();
    };
    const onHandleOk = () => {
        getUserInfo()
      setOpenVerificationModal(false);
    }
    return (
        <StyledCard
        >
            <Flex justify={"center"} vertical gap={"middle"}>
                <Flex justify={"center"}>

                    <Avatar

                        size={80}
                        src={profilePic}

                    />
                </Flex>

               <Flex justify={"center"} vertical >
                   <span className={style.CustomMobileNumber}>
                        {currentUser?.mobileNumber}
                   </span>

                   <span className={style.CustomEmail}>
                       {currentUser?.firstname} {currentUser?.lastname}
                   </span>
               </Flex>
                {currentUser?.isAuthenticated ?  <StyledTag bordered={false} color="success">
                    احراز شده
                </StyledTag> : <Button color={"default"} variant={"filled"} onClick={() => setOpenVerificationModal(true)}>
                    احراز هویت
                </Button>}
                { openVerificationModal && <VerifyIdentityPopup open={openVerificationModal} onHandleCancel={onCansel} onHandleOk={onHandleOk}/>}
            </Flex>

        </StyledCard>
    );
};

export default connect(null, {getUser})(withRouter(UserInformation));
